var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000B31",
    d: "M16.835 21.957a.87.87 0 0 1-.618-.257.88.88 0 0 1 0-1.237L22.68 14l-6.463-6.463a.88.88 0 0 1 0-1.237.88.88 0 0 1 1.236 0l7.082 7.082a.88.88 0 0 1 0 1.236L17.453 21.7a.87.87 0 0 1-.618.257"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000B31",
    d: "M23.719 14.875H4.083A.88.88 0 0 1 3.209 14c0-.478.396-.875.874-.875h19.635c.479 0 .875.397.875.875a.88.88 0 0 1-.875.875"
  })));
};
export default SvgArrowRight;